/**
 * A class invite someone opened while signed out, held until they've logged
 * in or signed up, so the join page can finish the job.
 *
 * localStorage rather than sessionStorage: signing up means confirming an
 * email, which opens in a new tab. If the journey is lost anyway (a different
 * device), an email invite is still accepted by the API at log-in.
 */
const KEY = "pendingClassJoin";

export const joinPath = (token) => `/join/${token}`;

export function rememberPendingJoin({ token, courseName, email }) {
  try {
    localStorage.setItem(KEY, JSON.stringify({ token, courseName, email: email || null }));
  } catch {
    /* storage unavailable: the API still applies email invites at log-in */
  }
}

/** `{ token, courseName, email }`, or null. */
export function pendingJoin() {
  try {
    const value = JSON.parse(localStorage.getItem(KEY) || "null");
    return value && value.token ? value : null;
  } catch {
    return null;
  }
}

export function clearPendingJoin() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* nothing to clear */
  }
}
